module.exports = __webpack_public_path__ + "img/c5.ff8ff013.png";